<div class="vh">
  @if (withOwnerArray) {
    <ng-container [formArray]="form.get('owners')">
      <div class="row">
        @for (
          owner of form.get('owners')?.controls;
          track owner;
          let index = $index
        ) {
          <ng-container>
            <div class="col-md-{{ form.get('owners')?.length > 1 ? 6 : 12 }}">
              <owner-header
                [owners]="form.get('owners')"
                [index]="index"
              ></owner-header>
              <ng-container
                [ngTemplateOutlet]="ownerTemplate"
                [ngTemplateOutletContext]="{ $implicit: owner, index: index }"
              >
                <ng-content></ng-content>
              </ng-container>
            </div>
          </ng-container>
        }
      </div>
    </ng-container>
  } @else {}
</div>
